import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

function MatrixResult({rows, cols, name, value}) {

    const [result, setResult] = useState(value ? value : new Array(rows).fill(0).map(a => new Array(cols).fill('')))
    const [render, setRender] = useState(0)

    const rowsComponents = []
    for(let i = 0; i < rows; i++) {
        let buffer = []
        for(let j = 0; j < cols; j++) {
            buffer.push((<Input
                onChange={a => {
                    if(!result[i]) result[i] = new Array(cols).fill('')
                    result[i][j] = a.target.value


                    setResult(result)
                    setRender(render + 1 );
                }}
                type='text' key={`input_${i}_${j}`}
                defaultValue={result[i] && result[i][j] ? result[i][j] : null}
            />))
        }


        rowsComponents.push(<Row key={`row_${i}`}>{buffer}</Row>)
    }

    return (
     <Wrapper>
         <input type='hidden' name={name} value={JSON.stringify(result)} />
         <Open />

         <Matrix>
             {rowsComponents}
         </Matrix>
         <Close />
     </Wrapper>
    );
}

export default MatrixResult;


const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`

const Matrix = styled.div`
  display: flex;
  flex-direction: column;

`
const Open = styled.div`
   height: ${props => props.cols * 30}px;
   border-left: 1px solid #7a7a7a;
   border-top: 1px solid #7a7a7a;
   border-bottom: 1px solid #7a7a7a;
   width: 4px

`

const Close = styled.div`
   height: ${props => props.cols * 30}px;
   border-right: 1px solid #7a7a7a;
   border-top: 1px solid #7a7a7a;
   border-bottom: 1px solid #7a7a7a;
   width: 4px
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
`


const Input = styled.input`
  padding: 4px;
  width: 30px;
  font-size: 16px;
  margin: 4px;
  text-align: center;
`;


if (document.getElementsByTagName('matrix-result')) {
    const elements = document.getElementsByTagName('matrix-result')

    for(let element of elements) {
        ReactDOM.render(
            <MatrixResult
                name={element.attributes.name ? element.attributes.name.value : null}
                rows={element.attributes.rows.value}
                cols={element.attributes.cols.value} />, element);
    }

}
